import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('SW registered: ', registration);

      // AZONNALI ELLENŐRZÉS: Ha már van várakozó frissítés betöltéskor
      if (registration.waiting) {
        window.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
      }

      // Figyeljük, ha van frissítés a háttérben
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Van új verzió, de még a régi fut. Szólunk az appnak!
              console.log('New content is available; please refresh.');
              window.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
            }
          }
        };
      };

      // Kényszerített frissítés-ellenőrzés minden indításkor (hibakezeléssel)
      registration.update().catch(err => console.log('SW update check skipped:', err.message));

      // Frissítés ellenőrzése, amikor a felhasználó visszatér az appba (hibakezeléssel)
      window.addEventListener('focus', () => {
        registration.update().catch(err => console.log('SW focus update check skipped:', err.message));
      });

    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError);
    });

    // ÚJ: AUTOMATIKUS ÚJRATÖLTÉS HA AZ ÚJ SW ÁTVETTE AZ IRÁNYÍTÁST
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        window.location.reload();
        refreshing = true;
      }
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
